import SingleSelectDropdownFilter from './SingleSelectDropdownFilter.component';

export default SingleSelectDropdownFilter;
